module.exports = __webpack_public_path__ + "static/media/f8d547aa-9d36-4640-9c55-17ca60a1566f.2e2c1c03.jpg";